module.exports = __webpack_public_path__ + "static/media/drill-day-3.ef8182aa.png";